<script>

import Popper from "vue3-popper";
import { useToast } from "vue-toastification";

import Datepicker from 'vue3-date-time-picker';
import 'vue3-date-time-picker/dist/main.css'



import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getStateOptions } from '@/services/serviceCommon';
import { getAccessRightsOptions } from '@/services/serviceAccessRight';
import { getWeather, unlockWeather, saveWeather, createWeather } from '@/services/weather/serviceWeather';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'WeatherEdit',
	mixins: [ MixinGeneralFunct ],
	components: {
		Popper
		,Datepicker
		,LoadingScreen
		,LoadingButton
		,Alert
	},
	props: {'weatherId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["weatherId","changeRecord"],
	data() {
	
		return {
			metaData:[],
			
			isLoading:true,
			isSending:false,
			
			isNewRecord:true,

			optionsAccessLevels: [],
			optionsStates:[],
			optionsLanguages:[],
			
			initObj: {
				
				relative_urls: false
				,convert_urls: false
				,remove_script_host:false
				,height:450
				,entity_encoding : "raw" 
				,language:'sk'
				,extended_valid_elements: 'i[class]'
				,iconfonts_selector: '.fa, .fab, .fal, .far, .fas, .glyphicon'
			},
			
						
			//form
			data:[],
			template:[]
			
		}
	},
	
	mounted:function(){
		
	},
	
	methods: {

		
		// load data form
		onLoadPage:function(){


			this.isLoading=true
			getWeather({weatherId:this.weatherId}).then(response => {
				if(!response.statusText){
					console.log(response)
					this.isLoading=false
					this.metaData = response.metaData;
					this.data = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getAccessRightsOptions().then(response => {
				if(!response.statusText){
					this.optionsAccessLevels = response.optionsAccessLevels;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getStateOptions().then(response => {
				if(!response.statusText){
					this.optionsStates = response.optionsStates;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});


			/*
			this.isLoading=true
			//console.log(this.weatherId)		
			if(this.weatherId=='null'){
				this.isNewRecord=true;
			}else if(this.weatherId && this.weatherId>0){
				this.isNewRecord=false;
			}
			
			var bodyFormData = new FormData();
			bodyFormData.set('weatherId',this.weatherId);
						
			axios({
				method: 'post',
				url: '/admins/app/customWeather/WeatherBasic/getWeatherData.php',
				data: bodyFormData
			})
			.then(response => {
			
				//console.log(response.data);
				this.metaData = response.data.metaData;
				
				//hide loader
				this.isLoading=false
				
				this.metaData = response.data.metaData;
								
				this.data = response.data.data;
				this.template = response.data.template;
				
				this.optionsAccessLevels = response.data.optionsAccessLevels;
				this.optionsStates = response.data.optionsStates;

			})
				.catch(function (error) {
				console.log(error);
				
				
			});*/
		
		},

		
		
		checkSave:function(){
								
			if(!this.data.date_current){this.data.date_currentError = true; }else{this.data.date_currentError = false;}
			if(!this.data.access){this.data.accessError = true; }else{this.data.accessError = false;}
						
			if(this.data.date_current && this.data.access){
				return true;
			}else{
				return false;
			}
		},	


		onSave:function(){
							
			if(this.checkSave()){
				if(this.weatherId!='null'){	
					this.isSending=true
					saveWeather({data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}else{
					createWeather({data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}	
			}
			
		},
		
	/*	saveWeather:function(){

			if(this.checkSave()){
				
				var bodyFormData = new FormData();
				bodyFormData.set('myWeather',JSON.stringify(this.data));
				
				axios({
					method: 'post',
					url: '/admins/app/customWeather/WeatherBasic/controlWeatherSave.php',
					data: bodyFormData
				})
				.then(response => {
					if (response.data.error) {
							console.log('error', response.data.error)
					} else {
						//console.log('success2', response.data);

						if(response.data.resCode==1){
							this.toast.success(this.$t('msgCore.dataWasSaved'));
							this.$emit('changeRecord', '')
							this.data = [];
						}else if(response.data.resCode==0){
							this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
						}else if(response.data.resCode==2){
							this.toast.error(this.$t('msgCore.dataWasNotSaved'));
						}else if(response.data.resCode==3){
							this.toast.error(this.$t('msgCore.accessDenied'));
						}
						
					}
				})
				.catch(error => {
					console.log(error.response)
				}); 
				
				
			}else{
				this.toast.warning(this.$t('msgCore.fillInAllData'));
			}
			
		},
*/

		onClose:function(){
			if(this.weatherId!='null'){
				
				unlockWeather(this.weatherId).then(response => {
					if(!response.statusText){
						console.log(response)
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},
		
		//odomknutie zaznamu
	/*	unLock:function(weatherId){
			
			this.cSession();
			var bodyFormData = new FormData();
			bodyFormData.set('myRecordID',weatherId);
			
			axios({
				method: 'post',
				url: '/admins/app/customWeather/WeatherBasic/controlWeatherUnlock.php',
				data: bodyFormData
			})
			.then(response => {
				if (response.data.error) {
						console.log('error', response.data.error)
				} else {
					//console.log(response.data);
					if(response.data==1){
						this.$emit('changeRecord', '')
					}else if(response.data==0){
						//xx
					}else if(response.data==2){
						//xx
					}else if(response.data==3){
						//xx
					}
					
				}
			})
			.catch(error => {
				console.log(error.response)
			}); 
			
		},*/

		
	},
	
	watch: {
		weatherId() {
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
	<div class="modal fade" :id="modalId" tabindex="-1" >
		<div class="modal-dialog modal-xl modal-dialog-scrollable">	
			<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCustomWeather.Weather') }} <span v-if="!data.isNewRecord"><b>{{ data.title }}</b> id: {{data.id}}</span></h6>
					</div>
			
							<div v-if="metaData.modulAccess && (auth.weatherNew || auth.weatherEdit)" class="modal-body">
								
								<div class="row">
									<div class="col-12">
										<div v-if="data.isCheckedOut && secData.userId != data.isCheckedOutId" class="angle">
											<span class="angle-inner" :class="{'angle-warning':data.isCheckedOut}"><i class="fa" :class="{'angle-warning':data.isCheckedOut, 'fa-exclamation-triangle':data.isCheckedOut}" aria-hidden="true"></i> {{$t('msgCore.Edited')}} </span >
											
											<Popper v-if="data.isCheckedOut" :content="data.isCheckedOutName+', '+data.isCheckedOutDate">
												<button class="personCircle v-center" v-bind:style="{background:data.isCheckedOutColor}">{{ data.isCheckedOutLetterName+''+data.isCheckedOutLetterSurname }}</button>
											</Popper>
											
										</div>
									</div>
								</div>
							
								<div class="row">
									
									<div class="col-md-8 col-12">
								
										<ul class="nav nav-tabs" role="tablist">
							
											<li class="nav-item">
												<a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">{{ $t('msgCore.basicData') }}</a>
											</li>
											
											
											
										</ul>

										<div class="tab-content" id="myTabContent">
								
											<div id="home" class="tab-pane fade show active" role="tabpanel">
											
												<div class="form-row">
												
													<div class="form-group col-md-6 col-12">
														<label :class="{'text-danger':data.date_currentError}"><b>{{ $t('msgCustomWeather.FromDate') }}</b> </label>
														<Datepicker v-model="data.date_current" format="yyyy-MM-dd" :locale="$i18n.locale"  @update:modelValue="checkSave()" :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')" :class="{'is-invalid':data.date_currentError}"></Datepicker>
														<div v-show="data.date_currentError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
													</div>
													
												</div>	


												<div class="form-row">
												
													<div class="form-group col-md-6 col-12">
														<label><b>Čas ráno</b> </label>
														<Datepicker v-model="data.morning_temp_date" format="yyyy-MM-dd HH:mm" :locale="$i18n.locale"  @update:modelValue="checkSave()" :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')"></Datepicker>
													</div>
													<div class="form-group col-md-6 col-12">
														<label><b>Teplota ráno</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.morning_temp_value" >
													</div>
													
												</div>	

												<div class="form-row">
												
													<div class="form-group col-md-6 col-12">
														<label><b>Čas obed</b> </label>
														<Datepicker v-model="data.atnoon_temp_date" format="yyyy-MM-dd HH:mm" :locale="$i18n.locale"  @update:modelValue="checkSave()" :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')"></Datepicker>
													</div>
													<div class="form-group col-md-6 col-12">
														<label><b>Teplota obed</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.atnoon_temp_value" >
													</div>
													
												</div>	

												<div class="form-row">
												
													<div class="form-group col-md-6 col-12">
														<label><b>Čas večer</b> </label>
														<Datepicker v-model="data.evening_temp_date" format="yyyy-MM-dd HH:mm" :locale="$i18n.locale"  @update:modelValue="checkSave()" :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')"></Datepicker>
													</div>
													<div class="form-group col-md-6 col-12">
														<label><b>Teplota večer</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.evening_temp_value" >
													</div>
													
												</div>	


												<div class="form-row">
												
													<div class="form-group col-md-6 col-12">
														<label><b>Sneh ráno - čas</b> </label>
														<Datepicker v-model="data.morning_snow_date" format="yyyy-MM-dd HH:mm" :locale="$i18n.locale"  @update:modelValue="checkSave()" :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')"></Datepicker>
													</div>
													<div class="form-group col-md-6 col-12">
														<label><b>Výška snehu ráno</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.morning_snow_value" >
													</div>
													
												</div>	

												<div class="form-row">
												
													<div class="form-group col-md-6 col-12">
														<label><b>Sneh obed - čas</b> </label>
														<Datepicker v-model="data.atnoon_snow_date" format="yyyy-MM-dd HH:mm" :locale="$i18n.locale"  @update:modelValue="checkSave()" :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')"></Datepicker>
													</div>
													<div class="form-group col-md-6 col-12">
														<label><b>Výška snehu obed</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.atnoon_snow_value" >
													</div>
													
												</div>	

												<div class="form-row">
												
													<div class="form-group col-md-6 col-12">
														<label><b>Sneh večer - čas</b> </label>
														<Datepicker v-model="data.evening_snow_date" format="yyyy-MM-dd HH:mm" :locale="$i18n.locale"  @update:modelValue="checkSave()" :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')"></Datepicker>
													</div>
													<div class="form-group col-md-6 col-12">
														<label><b>Výška snehu večer</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.evening_snow_value" >
													</div>
													
												</div>	


												<div class="form-row">
												
													<div class="form-group col-md-6 col-12">
														<label><b>Denné minimum</b> </label>
														<Datepicker v-model="data.min_temp_date" format="yyyy-MM-dd HH:mm" :locale="$i18n.locale"  @update:modelValue="checkSave()" :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')"></Datepicker>
													</div>
													<div class="form-group col-md-6 col-12">
														<label><b>Teplota min</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.min_temp_value" >
													</div>
													
												</div>	

												<div class="form-row">
												
													<div class="form-group col-md-6 col-12">
														<label><b>Denné maximum</b> </label>
														<Datepicker v-model="data.max_temp_date" format="yyyy-MM-dd HH:mm" :locale="$i18n.locale"  @update:modelValue="checkSave()" :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')"></Datepicker>
													</div>
													<div class="form-group col-md-6 col-12">
														<label><b>Teplota max</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.max_temp_value" >
													</div>
													
												</div>	


												<div class="form-row">
												
													<div class="form-group col-md-6 col-12">
														<label><b>Dážď - čas</b> </label>
														<Datepicker v-model="data.rain_date" format="yyyy-MM-dd HH:mm" :locale="$i18n.locale"  @update:modelValue="checkSave()" :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')"></Datepicker>
													</div>
													<div class="form-group col-md-6 col-12">
														<label><b>Dážď - výška v mm</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.rain_value" >
													</div>
													
												</div>	



											</div>
											
										</div>
										
									</div>
									
									<div class="col-md-4 col-12 form-control-system-data">
											
										<div class="form-row">
										
											<div class="form-group col-12">
												<label :class="{'text-danger':data.accessError}"><b>{{ $t('msgCore.AccessLevel') }}</b></label>
																									
												<select v-model='data.access' class="form-control form-control-sm " :class="{'is-invalid':data.accessError}" v-on:change="checkSave()">
													<option value="">{{ $t('msgCore.selectLevel') }}</option>
													<option v-for="(option) in optionsAccessLevels" :value="option.value" :key="option">{{ option.title }}</option>
												</select>
												<div v-show="data.accessError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectLevel')}}</span></div>
											</div>
											
											<div class="form-group col-12">
												<label :class="{'text-danger':data.stateError}"><b>{{ $t('msgCore.State') }}</b></label>
												
												<div  v-for="(option) in optionsStates" :key="option.value" class="form-check">
													<label class="form-check-label">
														<input class="form-check-input" type="radio" name="optionsStates"  v-model='data.state' v-on:change="checkSave()" :value="option.value">
														{{ $t('msgCore.'+option.title) }}
														<span class="circle">
															<span class="check"></span>
														</span>
													</label>
												</div>
												<div v-show="data.stateError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectState')}}</span></div>
											</div>
											
											
										
										</div>
										
									</div>										
																		
								</div>
								
							</div>
							
							<div v-else class="modal-body">
								<div class="row">
									<div class="col-12 mt-3">
										<Alert type="warning" :label="$t('msgCore.accessDenied')" />
									</div>
								</div>
							</div>
							
							<div class="modal-footer">
							
								<div class="btn-group">
									<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
									
									
									<LoadingButton :isDisabled="(!auth.weatherEdit || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onSave" :label="'msgCore.btnSave'" color="warning"></LoadingButton>
								</div>	
								
							</div>
						
				
					
					
				
				</div>

			</div>
			
		</div>
		

	</div>
	

</template>


